import { Link } from "@inertiajs/react"
import {
  Bot,
  Building2,
  Handshake,
  Search,
  Sparkles,
  Star,
  Users,
} from "lucide-react"
import { useState } from "react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  adminAccountsPath,
  adminAgentArchetypesPath,
  adminAgentsPath,
  adminPartnerUsersPath,
  adminPartnersPath,
  adminUsersPath,
} from "@/routes"
import type { NavItem } from "@/types"

import { AdminRecordLauncher } from "./admin-record-launcher"
import { AdminSearchDialog } from "./admin-search-dialog"
import AppLogo from "./app-logo"

const mainNavItems: NavItem[] = [
  {
    title: "Search",
    href: "#",
    icon: Search,
  },
  {
    title: "Partners",
    href: adminPartnersPath(),
    icon: Building2,
  },
  {
    title: "Accounts",
    href: adminAccountsPath(),
    icon: Star,
  },
]

const userNavItems: NavItem[] = [
  {
    title: "Client users",
    href: adminUsersPath(),
    icon: Users,
  },
  {
    title: "Partner users",
    href: adminPartnerUsersPath(),
    icon: Handshake,
  },
]

const agentNavItems: NavItem[] = [
  {
    title: "Archetypes",
    href: adminAgentArchetypesPath(),
    icon: Star,
  },
  {
    title: "Standard",
    href: `${adminAgentsPath()}?kind=standard`,
    icon: Bot,
  },
  {
    title: "Custom",
    href: `${adminAgentsPath()}?kind=custom`,
    icon: Sparkles,
  },
]

export function AdminSidebar() {
  const [searchOpen, setSearchOpen] = useState(false)

  return (
    <>
      <Sidebar collapsible="icon" variant="inset">
        <SidebarHeader>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton size="lg" asChild>
                <Link href={adminAccountsPath()} prefetch>
                  <div className="flex items-center gap-3">
                    <AppLogo variant="admin" />
                    <div className="flex flex-col">
                      <span className="text-sm font-medium">Imperative</span>
                      <span className="text-muted-foreground text-xs">
                        Admin
                      </span>
                    </div>
                  </div>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarHeader>

        <SidebarContent>
          <AdminRecordLauncher />
          <NavMain
            items={mainNavItems}
            onSearchClick={() => setSearchOpen(true)}
          />
          <NavMain items={userNavItems} label="Users" />
          <NavMain items={agentNavItems} label="Agents" />
        </SidebarContent>

        <SidebarFooter>
          <NavUser />
        </SidebarFooter>
      </Sidebar>
      <AdminSearchDialog open={searchOpen} onOpenChange={setSearchOpen} />
    </>
  )
}
